module.exports = __webpack_public_path__ + "img/revexpo_1969.61b790aa.jpg";